/*
 * VigorX v2 hero slider (sections/vx-hero.liquid).
 * Cross-fade + Ken Burns (CSS), copy swaps with the image, slanted progress segments.
 * Timers, not rAF (keeps running in background-throttled tabs the same way).
 * Pauses on hover/focus, swipe on phones, arrow keys on the dots. Reduced motion: no autoplay.
 */
(function () {
  'use strict';
  function init(root) {
    if (root.__vx) return; root.__vx = true;
    var slides = [].slice.call(root.querySelectorAll('.vx-hero__slide'));
    var copies = [].slice.call(root.querySelectorAll('.vx-hero__copy'));
    var dots = [].slice.call(root.querySelectorAll('.vx-hero__dot'));
    var n = slides.length; if (n < 2) return;
    var ms = parseInt(root.getAttribute('data-interval'), 10) || 7000;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, timer = 0, paused = false;
    root.style.setProperty('--vx-slide-ms', ms + 'ms');

    // Slides 2+ ship without src (see the section). Give them their image once the page has
    // loaded — off the critical path — and in any case before their turn (go() warms first).
    var warmed = false;
    function warm() {
      if (warmed) return; warmed = true;
      slides.forEach(function (s) {
        var im = s.querySelector('img[data-src]'); if (!im) return;
        if (im.dataset.srcset) im.srcset = im.dataset.srcset;
        im.src = im.dataset.src;
        im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
      });
    }
    function warmLater() { (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(warm, { timeout: 2500 }); }
    if (document.readyState === 'complete') setTimeout(warmLater, 600);
    else window.addEventListener('load', function () { setTimeout(warmLater, 600); }, { once: true });

    function go(k) {
      warm();
      k = (k + n) % n; if (k === i) return;
      slides[i].classList.remove('is-on'); slides[i].classList.add('is-off');
      var prev = slides[i]; setTimeout(function () { prev.classList.remove('is-off'); }, 1600);
      copies[i] && (copies[i].classList.remove('is-on'), copies[i].setAttribute('aria-hidden', 'true'));
      dots[i] && (dots[i].classList.remove('is-on'), dots[i].setAttribute('aria-selected', 'false'));
      i = k;
      slides[i].classList.add('is-on');
      copies[i] && (copies[i].classList.add('is-on'), copies[i].removeAttribute('aria-hidden'));
      if (dots[i]) { dots[i].classList.remove('is-on'); void dots[i].offsetWidth; dots[i].classList.add('is-on'); dots[i].setAttribute('aria-selected', 'true'); }
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      if (!paused && !reduce) { timer = setTimeout(function () { go(i + 1); }, ms); setTimeout(warm, Math.max(0, ms - 2500)); }
    }

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { go(k); });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { go(i + 1); dots[i].focus(); }
        if (e.key === 'ArrowLeft') { go(i - 1); dots[i].focus(); }
      });
    });
    root.addEventListener('mouseenter', function () { paused = true; root.classList.add('is-paused'); clearTimeout(timer); });
    root.addEventListener('mouseleave', function () { paused = false; root.classList.remove('is-paused'); schedule(); });
    root.addEventListener('focusin', function () { paused = true; root.classList.add('is-paused'); clearTimeout(timer); });
    root.addEventListener('focusout', function () { paused = false; root.classList.remove('is-paused'); schedule(); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 45) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else schedule(); });
    root.vxGo = go;
    schedule();
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-vx-hero]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
